const data = {
  id: 1,
  title: 'Choose the words in the box to fill in the blank.',
  subTitle: 'Chọn từ phù hợp để điền vào ô trống.',
  words: ['were', "don't", "wouldn't", 'since', 'in spite'],
  questions: ['My brother wants to be # dentist.', "I've been riding horses # I was 3 years old."],
  answers: ['were', 'since'],
};

export default data;
